<template>
	<v-container class="mt-4 ml-2" fluid>
	  <v-row>
	  	<v-col cols="12">
	  		<v-card class="shadowCard">
	  		  <v-card-title primary-title>
	  		    <span class="text-subtitle-1">Proveedores</span>
	  		    <v-spacer></v-spacer>
	  		    <v-btn 
              class="mr-2" 
              small dark color="green"
              @click="exportExcel( unidades  , 'unidades')"
              tile
            >
              <v-icon small>mdi-microsoft-excel</v-icon>
            </v-btn>

            <v-btn
              color="primary"
              dark
              class="mr-2"
              @click="dialog = true"
              small
              tile
            >
              <v-icon small>mdi-plus</v-icon>
            </v-btn>

            <v-btn
              color="orange"
              dark
              class="text-capitalize"
              @click="initialize()"
              small
              tile
            >
              <v-icon small>mdi-refresh</v-icon>
            </v-btn>

          </v-card-title>

          <v-card-text>
            <v-row justify="end">
              <v-col cols="12" md="8">
                <v-text-field
                  name="name"
                  label="Buscar"
                  id="id"
                  filled
                  dense
                  single-line
                  hide-details
                  append-icon="mdi-magnify"
                  v-model="search"
                >
                </v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12">
							  <v-data-table
							    :headers="headers"
							    :items="proveedores"
							    class="elevation-0"
							    :search="search"
							    :mobile-breakpoint="100"
			            dense
							  >
							    <!-- Valores que ocupan botons, chips, iconos, etc -->
							    <template v-slot:item.tipo="{ item }">
							      <v-chip 
							      	v-if="item.tipo == 1"
							      	small
							      	color="green"
							      	dark
							      	label
							      	outlined
							      >Ingreso</v-chip>

							      <v-chip 
							      	v-else
							      	small
							      	color="error"
							      	dark
							      	label
							      	outlined
							      >Egreso</v-chip>
							    </template>
							  
							    <template v-slot:item.color="{ item }">
							    	<v-chip 
							    		:color="item.color"
							    		rounded
							    		small 
							    	>
							    	</v-chip>
							    </template>

							    <template v-slot:item.actions="{ item }">
							    	<v-btn 
							    		color="primary" 
							    		x-small
							    		@click="editItem(item)"
							    		class="mr-2"
							    	>
								      <v-icon small>mdi-magnify</v-icon>
							    	</v-btn>

							    	<v-btn 
							    		color="error" 
							    		x-small
							    		@click="deleteItem(item)"
							    		class="mr-2"
							    	>
								      <v-icon small> mdi-delete</v-icon>
							    	</v-btn>
							    </template>

							    <template v-slot:no-data>
							      <v-btn
							        color="primary"
							        @click="initialize"
							        small
							      >
							        Actualizar
							      </v-btn>
							    </template>

							  </v-data-table>
	  		    	</v-col>
	  		    </v-row>
	  		  </v-card-text>
	  		</v-card>
	  	</v-col>
	  </v-row>

	  <!-- Dialogo de editar o agregar-->
	  <v-dialog
      v-model="dialog"
      max-width="800px"
      persistent
    >
      <v-card>
        <v-card-title>
          <span class="text-subtitle-1">{{ formTitle }}</span>
          <v-spacer></v-spacer>
          <span class="text-subtitle-1">
          	<strong>ID: {{ editedItem.idproveedores }}</strong>
          </span>
        </v-card-title>

        <v-card-text>

        	<v-row>
        		<v-col cols="12">
		          <label>Nombre o Razón Social</label>
		          <v-text-field
		            v-model="editedItem.proveedor"
		            filled
		            single-line
		            dense
		            hide-details
		          ></v-text-field>
        		</v-col>
        		
        		<v-col cols="12" md="4">
		          <label>RFC</label>
		          <v-text-field
		            v-model="editedItem.rfc"
		            filled
		            single-line
		            dense
		            hide-details
		          ></v-text-field>
        		</v-col>

        		<v-col cols="12" md="4">
		          <label>Calle</label>
		          <v-text-field
		            v-model="editedItem.calle"
		            filled
		            single-line
		            dense
		            hide-details
		          ></v-text-field>
        		</v-col>

        		<v-col cols="12" md="4">
		          <label># num.</label>
		          <v-text-field
		            v-model="editedItem.num"
		            filled
		            single-line
		            dense
		            hide-details
		          ></v-text-field>
        		</v-col>

        		<v-col cols="12" md="4">
		          <label>Municipio</label>
		          <v-text-field
		            v-model="editedItem.municipio"
		            filled
		            single-line
		            dense
		            hide-details
		          ></v-text-field>
        		</v-col>

        		<v-col cols="12" md="4">
        			<label>CP</label>
		          <v-text-field
		            v-model="editedItem.cp"
		            filled
		            single-line
		            dense
		            hide-details
		          ></v-text-field>
        		</v-col>

        		<v-col cols="12" md="4">
        			<label>Teléfono 1</label>
		          <v-text-field
		            v-model="editedItem.telefono1"
		            filled
		            single-line
		            dense
		            hide-details
		          ></v-text-field>
        		</v-col>

        		<v-col cols="12" md="4">
        			<label>Teléfono 2</label>
		          <v-text-field
		            v-model="editedItem.telefono2"
		            filled
		            single-line
		            dense
		            hide-details
		          ></v-text-field>
        		</v-col>

        		<v-col cols="12" md="8">
        			<label>Correo</label>
		          <v-text-field
		            v-model="editedItem.correo"
		            filled
		            single-line
		            dense
		            hide-details
		          ></v-text-field>
        		</v-col>

        		<v-col cols="12">
        			<label>Persona que atiende</label>
		          <v-text-field
		            v-model="editedItem.empleado"
		            filled
		            single-line
		            dense
		            hide-details
		          ></v-text-field>
        		</v-col>

        		<v-col cols="12" md="6">
        			<label>Cuenta Clabe</label>
		          <v-text-field
		            v-model="editedItem.cuenta_clave"
		            filled
		            single-line
		            dense
		            hide-details
		          ></v-text-field>
        		</v-col>

        		<v-col cols="12" md="6">
        			<label>Número de tarjeta</label>
		          <v-text-field
		            v-model="editedItem.numero_tarjeta"
		            filled
		            single-line
		            dense
		            hide-details
		          ></v-text-field>
        		</v-col>

        		<v-col cols="12" md="6">
        			<label>Banco</label>
		          <v-text-field
		            v-model="editedItem.banco"
		            filled
		            single-line
		            dense
		            hide-details
		          ></v-text-field>
        		</v-col>

        		<v-col cols="12" md="6">
        			<label>Tipo (s) de Producto o Servicio:</label>
		          <v-text-field
		            v-model="editedItem.servicio"
		            filled
		            single-line
		            dense
		            hide-details
		          ></v-text-field>
        		</v-col>

        		<v-col cols="12" md="6">
        			<label>Tipo (s) de Mano de Obra / Maquila:</label>
		          <v-text-field
		            v-model="editedItem.maquila"
		            filled
		            single-line
		            dense
		            hide-details
		          ></v-text-field>
        		</v-col>
        	</v-row>

        </v-card-text>

        <v-card-actions>
          <v-btn
            color="red"
            dark
            dense
            small
            @click="close"
          >
            Cancelar
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            dark
            dense
            small
            @click="save"
          >
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialogo para eliminar -->
    <v-dialog v-model="dialogDelete" max-width="500px">
      <v-card>
      	<v-card-text>
	      	<v-row justify="space-around">
	      		<v-col cols="6">
	      			<v-card class="elevation-0" height="100%" style="display: table;">
		      			<div class="text-subtitle-1" style="display: table-cell; vertical-align: middle;">
		      				<strong>Eliminar</strong> ¿Estás seguro que deseas eliminar el proveedor?
			      			<v-card-actions class="pt-6">
			      				<!-- Cerrar dialogo de confirmación y abrir el dialogo de editar la clase -->
			      			  <v-btn color="error" text  class="mr-2" @click="closeDelete()">No, cancelar</v-btn>
			      			  <!-- Guardar la información  -->
			      			  <v-btn color="#5C5C5C"  dark class="elevation-6"  @click="deleteItemConfirm()">Si</v-btn>
			      			</v-card-actions>
		      			</div>
	      			</v-card>
	      		</v-col>
	      		<v-col cols="5">
	      			<v-img src="@/assets/borrar.png"></v-img>
	      		</v-col>
		      </v-row>
      	</v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog de carga -->
    <Alerta               v-if="respuestaAlerta"             :parametros="parametros"/>
    <carga                v-if="cargar"/>

	</v-container>
</template>
<script>
	import { mapGetters } from 'vuex'
	// Componentes
  import Alerta                from '@/components/alertas/Alerta.vue'
  import carga                 from '@/components/alertas/carga.vue';

  import validarErrores        from '@/mixins/validarErrores'

  export default {
  	components:{
      Alerta,
      carga,
    },

    mixins: [ validarErrores ],
    
    data: () => ({
    	// Alertas
    	parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

      respuestaAlerta:false,
      loader: true,
      cargar: false,

      dialog: false,
      dialogDelete: false,
      
      editedIndex: -1,

      editedItem: {
        idproveedores:0,
        rfc:'',
				proveedor:'', 
				calle:'', 
				num:'', 
				municipio:'', 
				cp:'', 
				telefono1:'', 
				telefono2:'', 
				correo:'', 
				empleado:'', 
				cuenta_clave:'', 
				numero_tarjeta:'', 
				banco:'', 
				servicio:'', 
				maquila:'',
				fecha_creacion: null,
				deleted: 0
      },

      defaultItem: {
        idproveedores:0,
        rfc:'',
				proveedor:'', 
				calle:'', 
				num:'', 
				municipio:'', 
				cp:'', 
				telefono1:'', 
				telefono2:'', 
				correo:'', 
				empleado:'', 
				cuenta_clave:'', 
				numero_tarjeta:'', 
				banco:'', 
				servicio:'', 
				maquila:'',
				fecha_creacion: null,
				deleted: 0
      },

      // Filtros: 
      incio:null,
			fin:null,

      // tabla
			search:'',
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      proveedores: [],
      headers: [
        { text: 'ID'          , value: 'idproveedores'  },
        { text: 'Proveedor'   , value: 'proveedor'      },
        { text: 'Teléfono 1'  , value: 'telefono1'      },
        { text: 'Empleado'    , value: 'empleado'       },
        { text: 'Servicio'    , value: 'servicio'       },
        { text: 'Maquila'     , value: 'maquila'        },
        { text: 'Alta'        , value: 'fecha_creacion' },
        { text: 'Actions'     , value: 'actions', sortable: false },
      ],
    }),

    computed: {
    	...mapGetters('login',['getdatosUsuario']),
      formTitle () {
        return this.editedIndex === -1 ? 'Agregar proveedor' : 'Editar proveedor'
      },
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },

    },

    async created () {
      await this.initialize()
    },

    methods: {
      initialize () {
      	this.cargar = true
        this.proveedores = []
        return this.$http.get('proveedores.list').then(response=>{
        	this.proveedores = response.body
        	this.cargar      = false
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      editItem (item) {
        this.editedIndex = this.proveedores.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      deleteItem (item) {
        this.editedIndex = this.proveedores.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
      },

      deleteItemConfirm () {
      	this.cargar = true
        // Lo mandapos por el EP
        this.editedItem.deleted = 1
        this.$http.put('proveedores.update/' + this.editedItem.idproveedores, this.editedItem).then(response=>{
        	this.cargar = true
        	this.closeDelete()
        	this.initialize()
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      save () {
	      this.cargar = true

        if (this.editedIndex > -1) {
	        // Lo mandapos por el EP
          this.$http.put('proveedores.update/' + this.editedItem.idproveedores, this.editedItem).then(response=>{
            this.close( )
          	this.validarSuccess( response.body.message )
          	this.initialize()
	        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })

        } else {
	        // Lo mandapos por el EP
          this.$http.post('proveedores.add', this.editedItem).then(response=>{
            this.close( )
          	this.initialize()
	        	this.cargar = false
	        }).catch( error =>{
          	this.validarError( error )
        	}).finally( () => { this.cargar = false })
        }
      },
    },
  }
</script>


